import { type ForwardedRef, type ReactNode } from 'react';
import { forwardRef } from 'react';
import styled from 'styled-components';

import { Card } from '@hivebrite/design-system/Card';
import { Skeleton } from '@hivebrite/design-system/Skeleton';
import { type Breakpoint } from '@hivebrite/design-system/Theme';
import { useMatchBreakpoint } from '@hivebrite/design-system/Theme';
import { useMeasure } from '@hivebrite/react-hooks';

export const WrapperCard = forwardRef(
  (
    {
      children,
      height,
      width,
      ...props
    }: {
      children: ReactNode;
      height?: Breakpoint;
      width?: Breakpoint;
    },
    ref: ForwardedRef<HTMLDivElement>,
  ) => (
    <Card height={height} p={0} ref={ref} width={width} {...props}>
      {children}
    </Card>
  ),
);

export const NewsCardLoader = () => {
  const isXL = useMatchBreakpoint('xl');

  const [ref, , { height, width }] = useMeasure<HTMLDivElement>();

  return (
    <WrapperCard height={{ _: 285, m: 289, l: 344, xl: 358 }} ref={ref}>
      {height && width && (
        <>
          <RoundedSkeleton width={width} />
          <TextSkeleton height={16} mt={4} width={width - 32} />
          {isXL && <TextSkeleton height={16} mt={3} width={width - 32} />}
          <TextSkeleton height={12} mt={3} width={(width - 32) / 3} />
          <TextSkeleton height={12} mt={3} width={width - 32} />
          <TextSkeleton height={12} mt={2} width={width - 32} />
        </>
      )}
    </WrapperCard>
  );
};

const RoundedSkeleton = styled(Skeleton).attrs({
  height: { _: 159, m: 162, l: 217, xl: 205 },
  isLarge: true,
})`
  border-radius: ${({ theme }) => {
    const br = theme.themeVariables.globalBorderRadius;

    return `${br}px ${br}px 0 0`;
  }};
`;

const TextSkeleton = styled(Skeleton).attrs({
  isLarge: true,
  mx: 4,
})``;
